
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"16","viewBox":"0 0 20 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.125 3h-7.5L8.491.866A1.25 1.25 0 007.607.5H1.875C.839.5 0 1.34 0 2.375v11.25C0 14.661.84 15.5 1.875 15.5h16.25c1.035 0 1.875-.84 1.875-1.875v-8.75C20 3.839 19.16 3 18.125 3zm0 10.625H1.875V2.375h5.473l2.134 2.134c.235.234.553.366.884.366h7.759v8.75z","fill":"#0B0E1F"}})])
          )
        }
      }
    